const allUnitReceipt = { data: [], loading: true };
const allUnitTableData = { data: [], loading: true, cache: {} };

export const GetAllUnitReceiptRed = (state = allUnitReceipt, action) => {
  switch (action.type) {
    case "get_allunitreceipt":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
export const GetAllUnitReceiptTableRed = (state = allUnitTableData, action) => {
  switch (action.type) {
    case "get_allunittabledata":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "clear_unitreceipt_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
